import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Section from '../../../components/Section';

import styles from './About.module.css';

export const About: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'NAVIGATE') {
        navigate(event.data.path);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [navigate]);

  if (import.meta.env.SSR) {
    return null;
  }

  return (
    <div className={styles.about}>
      <Section>
        <iframe
          src={`https://jam-customer-care-hub.lovable.app/about?homePageUrl=${window.location.origin}`}
          className={styles.iframe}
          title="About"
        />
      </Section>
    </div>
  );
};
